import styled from 'styled-components';

export default styled.nav`
  box-sizing: border-box;
  height: calc(100% - ${({ hasNews }) => hasNews ? '90px' : '60px'});
  padding: 5px;
`;
